<template>
  <div>
    <Head :title="__('Log In')" />

    <form
      @submit.prevent="attempt"
      class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto"
    >
      <h2 class="text-2xl text-center font-normal mb-6">
        {{ __('Welcome Back!') }}
      </h2>

      <DividerLine />

      <LoadingButton
        class="w-full flex justify-center"
        type="submit"
        :disabled="isLoading"
        :loading="isLoading"
      >
        <span>
          {{ __('Log In') }}
        </span>
      </LoadingButton>
    </form>
  </div>
</template>

<script>
import Auth from '@/layouts/Auth'

export default {
  name: 'LoginPage',

  layout: Auth,

  data() {
      return {
          isLoading: false,
      };
  },

  methods: {
    attempt() {
      this.isLoading = true;

      try {
        Nova.visit({
            url: '/auth/login',
            remote: true
        });
      } catch (error) {
        if (error.response?.status === 500) {
          Nova.error(this.__('There was a problem submitting the form.'))
        }
      } finally {
          this.loading = false;
      }
    },
  },
}
</script>
